import ApiService from 'Services/ApiService'

export default {
    getUser() {
        return ApiService.get('auth/user')
    },
    updateNotifications(data) {
        return ApiService.update('settings/update-notifications', data)
    },
    updateCF(data) {
        return ApiService.update('settings/update-custom-fields', data)
    },
    updatePassword(data) {
        return ApiService.update('settings/update-password', data)
    },
    updateP1Integration(data) {
        return ApiService.upload('settings/update-p1-integration', data)
    },
    newPassword(data) {
        return ApiService.post('auth/password-reset/update', data)
    },
    resetPassword(data) {
        return ApiService.post('auth/password-reset/send', data)
    },
    exportPatientDoc(patientId, query) {
        return ApiService.download(`settings/export-patient-documentation/${patientId}`, {params: query})
    },
    transferPatientDoc(patientId, pwz) {
        return ApiService.post(`settings/transfer-patient-documentation/${patientId}`, {
            params: {
                pwz: pwz
            }
        })
    }
}
